import React, { useEffect } from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { LocalizationProvider } from '@mui/x-date-pickers';
import AppFrame from './components/AppFrame';
import SideContent from './components/AppFrame/SideContent';
import { Error403 } from './components/Error403';
import { customTheme, getThemeName } from './theme';
import * as routeActions from './redux/actions/route.actions';
import * as userActions from './redux/actions/user.actions';
import PermissionsService from './services/permissions.service';
import { removeSpinner } from './utils/spinner.utils';

const App = props => {
  const { routeChange, match, user } = props;

  useEffect(() => {
    routeChange(match);
  }, [match, routeChange]);

  const hasAccess = PermissionsService.hasAccess(user);

  useEffect(() => {
    if (!hasAccess) {
      removeSpinner();
    }
  }, [hasAccess]);

  if (!hasAccess) {
    return <Error403 />;
  }

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={customTheme(getThemeName(window.ambulnzConfig.constants, user))}>
        <CssBaseline />
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <AppFrame {...props}>
            <SideContent />
          </AppFrame>
        </LocalizationProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

App.propTypes = {
  user: PropTypes.shape().isRequired,
  routeChange: PropTypes.func.isRequired,
  match: PropTypes.shape().isRequired,
  phone: PropTypes.string.isRequired,
};

function mapStateToProps(state) {
  return {
    user: state.user.model,
    isUserAmbAdmin: state.user.isUserAmbAdmin,
    preferredFacility: state.user.preferredFacility,
    phone: state.supportPhone.phone,
  };
}

export default connect(mapStateToProps, { ...routeActions, ...userActions })(App);
